import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Badge,
  Box,
  Tooltip,
} from '@mui/material';
import { Favorite } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useFavorites } from '../contexts/FavoritesContext';
import FavoritesSidebar from './FavoritesSidebar';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const { favorites } = useFavorites();
  const [favoritesOpen, setFavoritesOpen] = useState(false);

  const handleHomeClick = () => {
    navigate('/');
  };

  const handleFavoritesClick = () => {
    setFavoritesOpen(true);
  };

  return (
    <>
      <AppBar 
        position="sticky" 
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Box 
            onClick={handleHomeClick}
            sx={{ 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              transition: 'all 0.2s ease',
              '&:hover': {
                transform: 'scale(1.05)',
              }
            }}
          >
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 800,
                fontSize: '1.5rem',
                background: 'linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                textShadow: '0 2px 10px rgba(0,0,0,0.1)',
              }}
            >
              FindFunNow
            </Typography>
          </Box>

          <Tooltip title="Favorites" placement="bottom">
            <IconButton
              color="inherit"
              onClick={handleFavoritesClick}
              sx={{
                color: 'white',
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                  transform: 'scale(1.1)',
                },
              }}
            >
              <Badge 
                badgeContent={favorites.length} 
                color="error"
                sx={{
                  '& .MuiBadge-badge': {
                    background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                    color: 'white',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    minWidth: '20px',
                    height: '20px',
                    borderRadius: '10px',
                    border: '2px solid white',
                    boxShadow: '0 2px 8px rgba(239, 68, 68, 0.3)',
                  },
                }}
              >
                <Favorite />
              </Badge>
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <FavoritesSidebar 
        open={favoritesOpen} 
        onClose={() => setFavoritesOpen(false)} 
      />
    </>
  );
};

export default Navbar;